/* tslint:disable */
/* eslint-disable */

import { exists, mapValues } from '../runtime';
/**
 *
 * @export
 * @interface LinkFaxToReferralRequest
 */
export interface LinkFaxToReferralRequest {
    /**
     *
     * @type {string}
     * @memberof LinkFaxToReferralRequest
     */
    lead_id: string;
    /**
     *
     * @type {boolean}
     * @memberof LinkFaxToReferralRequest
     */
    include_in_ai_analysis: boolean;
}

/**
 * Check if a given object implements the LinkFaxToReferralRequest interface.
 */
export function instanceOfLinkFaxToReferralRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "lead_id" in value;
    isInstance = isInstance && "include_in_ai_analysis" in value;

    return isInstance;
}

export function LinkFaxToReferralRequestFromJSON(json: any): LinkFaxToReferralRequest {
    return LinkFaxToReferralRequestFromJSONTyped(json, false);
}

export function LinkFaxToReferralRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkFaxToReferralRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'lead_id': json['lead_id'],
        'include_in_ai_analysis': json['include_in_ai_analysis'],
    };
}

export function LinkFaxToReferralRequestToJSON(value?: LinkFaxToReferralRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'lead_id': value.lead_id,
        'include_in_ai_analysis': value.include_in_ai_analysis,
    };
}
